import React from 'react';


const GDBestForYouSection = () => {
    return (
        <div className="section section-padding relative" style={{ overflow: 'hidden' }}>
            <div style={{
                background: "linear-gradient(to bottom, #F2F2FF, #FFFFFF)",
                position: 'relative',
                zIndex: 1
            }}>
                <div className="container">
                    <div className="section-heading heading-center mb--40">
                        <div className="text-center mb-5">
                            <p className="text-danger mb-2">Our Process</p>
                            <h2 className="display-4 fw-bold">Best For You</h2>
                        </div>
                    </div>
                    <div style={{ paddingBlock: '60px' }} className="text-center">
                        {/* Desktop image */}
                        <img
                            src={process.env.PUBLIC_URL + "/images/banner/GD-best-for-you.png"}
                            alt="Banner Desktop"
                            className="d-none d-lg-block img-fluid"
                        />

                        {/* Mobile & Tablet image */}
                        <img
                            src={process.env.PUBLIC_URL + "/images/banner/GD-best-for-you-mobile.png"}
                            alt="Banner Mobile"
                            className="d-block d-lg-none img-fluid width-full w-md-70 mx-auto"
                        />
                    </div>

                </div>
            </div>

            {/* Full width SVG positioned absolutely */}
            <svg
                width="100%"
                height={275}
                viewBox="0 0 1920 275"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="SMM-section-curve-line"
                preserveAspectRatio="none"
            >
                <mask
                    id="mask0_24_38"
                    style={{
                        maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={1920}
                    height={275}
                >
                    <path
                        d="M0 6.23198C318.332 274.567 688.226 -17.9956 1033.19 0.884379C1245.07 12.478 1640.23 164.457 1920 129.262V274.567H0C0 185.122 0 95.6773 0 6.23198Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_24_38)">
                    <path d="M1920 -18H0V274.563H1920V-18Z" fill="#F2F2FF" />
                </g>
            </svg>

            <style jsx>{`
            .w-md-70 {
                width: 70% !important;
            }

                .SMM-section-curve-line {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: 100vw;
                    height: auto;
                    top:0;
                    z-index: 0;
                    margin-left: calc(-50vw + 50%);
                }

                @media (max-width: 767px) {
                    .width-full {
                        width: 100% !important;
                    }
                }
                .animate-fade-in {
                    animation: fadeInUp 0.6s ease-out;
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default GDBestForYouSection;